import { useEffect,useState } from "react";
import {getSecureImageUrl} from "../utils/util";

export const useSecureUrl = (url) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!url || url === 'null' || url === 'undefined') return;

    if (url.includes('https://lh3.googleusercontent.com')) {
      const googleUrl = url.substring(url.indexOf('https://lh3.googleusercontent.com'));
      setSrc(googleUrl);
      return;
    }

    if (
      url.startsWith('blob:') || 
      url.startsWith('data:') || 
      (url.startsWith('https') && !url.includes(process.env.REACT_APP_API_PATH))
    ) {
          setSrc(url);
          return;
        }

    let objectUrl = null; // local variable instead of src state
    getSecureImageUrl(url)
      .then((blobUrl) => {
        objectUrl = blobUrl;
        setSrc(blobUrl);
      })
      .catch(() => setSrc(null));

    return () => {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl); // ✅ no stale src dependency
    };
  }, [url]);

  return src;
};